module.exports = __webpack_public_path__ + "static/img/character-boy-3.7311a12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/characters/character-boy-3.png
// module id = +hUp
// module chunks = 0